export default __webpack_public_path__ + "static/media/bgm-005.f69adb4a.mp3";